import { useCallback } from 'react'
import { View } from 'ol'

const DEFAULT_VIEW = {
  center: [0, 0],
  zoom: 3,
}

interface defaultViewProps {
  center?: number[]
  zoom?: number
}

interface customViewProps {
  defaultView?: defaultViewProps
}

function useCustomView({ defaultView }: customViewProps) {
  const createView = useCallback((): View => {
    return new View({
      center: defaultView?.center || DEFAULT_VIEW.center,
      zoom: defaultView?.zoom || DEFAULT_VIEW.zoom,
    })
  }, [])

  return createView
}

export default useCustomView
